// extracted by mini-css-extract-plugin
module.exports = {"ecgLoader":"EcgLoader_ecgLoader__31tYF","pulse":"EcgLoader_pulse__2gkTE","dash":"EcgLoader_dash__2he3L"};